export default "__VITE_ASSET__qVKIs4kc__"